import {
	Entry,
	ErrorModal,
	useEntries,
	useShiftNavigator,
} from "@dexteel/mesf-core";
import { Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useState } from "react";

import { useGridDefinitions } from "@/controls/ag-grid/components/GridDefinitions";
import { CenteredLazyLoading } from "@/controls/LazyLoading";
import { useTableData } from "./useTableData";

type Props = {
	assetId?: number | null;
};

export const TableLogbook = ({ assetId = 12 }: Props) => {
	const { shiftInfo } = useShiftNavigator();

	const [error, setError] = useState("");

	const {
		data: rows,
		isLoading,
		error: e,
		isError,
		refetch,
	} = useEntries({
		shiftId: shiftInfo?.CurrentShiftId,
		assetId: assetId ?? 12,
	});

	const { columnDefs } = useTableData();
	const { defaultColDef } = useGridDefinitions({});

	return (
		<>
			<Paper
				elevation={2}
				sx={{
					height: "100%",
					width: "100%",
					"& .ag-cell": {
						fontSize: 11,
					},
				}}
			>
				<AgGridReact<Entry>
					loading={isLoading}
					rowData={rows || []}
					columnDefs={columnDefs}
					defaultColDef={defaultColDef}
					rowHeight={30}
					headerHeight={34}
					animateRows
					getRowId={(params) => String(params.data.EntryId)}
					loadingOverlayComponent={CenteredLazyLoading}
				/>
			</Paper>
			<ErrorModal error={error} onHide={() => setError("")} />
		</>
	);
};
